import React, { Component } from 'react'
import api from '../api/api'

import { withStyles } from '@mui/styles'

import AddCircleIcon from '@mui/icons-material/AddCircle'
import CloseIcon from '@mui/icons-material/Close'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import {
  AppBar,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Checkbox,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Slide,
  TextField,
  Toolbar,
  Tooltip,
  FormControlLabel,
  Typography,
} from '@mui/material'

import { grey, red } from '@mui/material/colors'
import { DataGrid } from '@mui/x-data-grid'

const styles = (theme) => ({
  appBar: {
    position: 'static',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  error: {
    fontSize: '20px',
    color: red[400],
  },
  floatingButton: {
    bottom: 0,
    right: 0,
  },
  form: {
    backgroundColor: '#fafafa',
    width: '98%',
    marginLeft: 13,
    marginTop: theme.spacing(3),
  },
  formTextField: {
    backgroundColor: '#ffffff',
    fontSize: 14,
  },
  medicalAidGrid: {
    background: 'linear-gradient(45deg, #cb5921D0 30%, #a99787D0 90%)',
  },
  submitButton: {
    display: 'block',
    color: 'white',
    textAlign: 'center',
    position: 'absolute',
    right: 10,
  },
  subTitle: {
    fontSize: '22px',
    width: 220,
    color: grey[800],
    top: 20,
    bottom: 20,
    background: 'linear-gradient(45deg, #cb5921D0 30%, #a99787D0 90%)',
    borderRadius: '8px',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  toolbar: theme.mixins.toolbar,
  uiProgess: {
    position: 'fixed',
    zIndex: '1000',
    height: '31px',
    width: '31px',
    left: '50%',
    top: '35%',
  },
})

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" {...props} ref={ref} />
))

const medicalAidColumns = [
  {
    field: 'name',
    headerName: 'Medical Aid',
    width: 300,
    editable: false,
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 320,
    editable: false,
  },
  {
    field: 'requiresDiscoveryPdf',
    headerName: 'Discovery PDF',
    width: 150,
    editable: false,
    valueFormatter: (params) => (params.value ? 'Yes' : 'No'),
  },
]

const medicalAid0 = {
  id: Math.random(),
  name: '',
  email: '',
  requiresDiscoveryPdf: false,
}

const isValidEmail = (email) => {
  const value = String(email || '').trim()
  if (value === '') return false
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
}

const validateMedicalAid = ({ name, email }) => {
  const errors = {
    name: String(name || '').trim() === '',
    email: !isValidEmail(email),
  }

  const hasErrors = Object.values(errors).some(Boolean)
  return { errors, hasErrors }
}

const normalizeMedicalAid = (medicalAid) => {
  const { id, name, email, requiresDiscoveryPdf } = medicalAid

  return {
    id,
    name: String(name || '').trim(),
    email: String(email || '').trim().toLowerCase(),
    requiresDiscoveryPdf: !!requiresDiscoveryPdf,
  }
}

class medicalAid extends Component {
  constructor(props) {
    super(props)

    this.state = {
      buttonType: '',
      deleteInfo: 0,
      displaySubMenuButtons: 0,
      error: false,
      errors: {},
      login: false,
      medicalAid: {},
      medicalAids: [],
      mouseX: null,
      mouseY: null,
      open: false,
      opendel: false,
      uiLoading: true,
    }
  }

  componentDidMount = () => {
    this.fetchMedicalAids()
  }

  fetchMedicalAids = async () => {
    try {
      const response = await api.get(`/medicalAids/`)
      this.setState({
        medicalAids: response.data,
        uiLoading: false,
      })
    } catch (error) {
      if (error.response?.status === 403) {
        this.setState({ login: true })
      } else {
        this.setState({ uiLoading: false })
        console.log(error)
      }
    }
  }

  async createMedicalAid(userMedicalAid) {
    const response = await api.post('/medicalAid/', userMedicalAid)

    this.setState((prev) => ({
      medicalAid: response.data,
      medicalAids: [response.data, ...prev.medicalAids],
      open: false,
      uiLoading: false,
    }))
  }

  async updateMedicalAid(id, userMedicalAid) {
    await api.put(`/medicalAid/${id}`, userMedicalAid)

    this.setState((prev) => ({
      medicalAids: prev.medicalAids.map((item) =>
        item.id === id ? { ...userMedicalAid, id } : item
      ),
      open: false,
      uiLoading: false,
    }))
  }

  handleCreateOrEditMedicalAid = async (event) => {
    event.preventDefault()

    if (!this.props.isAdmin) {
      return
    }

    const normalized = normalizeMedicalAid(this.state.medicalAid)
    const { id, ...userMedicalAid } = normalized

    const { errors, hasErrors } = validateMedicalAid(userMedicalAid)
    this.setState({ errors })

    if (hasErrors) return

    this.setState({ uiLoading: true })

    try {
      if (this.state.buttonType === 'Edit') {
        await this.updateMedicalAid(id, userMedicalAid)
      } else {
        await this.createMedicalAid(userMedicalAid)
      }
    } catch (error) {
      if (error.response?.status === 403) {
        this.setState({ login: true })
      } else {
        this.setState({ uiLoading: false })
        console.error(error)
      }
    }
  }

  handleDeleteMedicalAid = async () => {
    if (!this.props.isAdmin) {
      return
    }

    const medicalAidId = this.state.medicalAid.id
    try {
      this.setState({ uiLoading: true })
      await api.delete(`/medicalAid/${medicalAidId}`)
      const medicalAids = [...this.state.medicalAids.filter((x) => x.id !== medicalAidId)]
      this.setState({
        deleteInfo: 1,
        displaySubMenuButtons: 0,
        medicalAids,
        mouseX: null,
        mouseY: null,
        opendel: false,
        uiLoading: false,
      })
    } catch (error) {
      if (error.response?.status === 403) {
        this.setState({ login: true })
      } else {
        this.setState({ uiLoading: false })
        console.log(error)
      }
    }
  }

  handleChange = (event) => {
    const medicalAid = { ...this.state.medicalAid }
    medicalAid[event.target.name] = event.target.type === 'checkbox'
      ? event.target.checked
      : event.target.value
    this.setState({ medicalAid })
  }

  handleClickToCreate = () => {
    if (!this.props.isAdmin) {
      return
    }

    this.setState({
      buttonType: 'Create',
      deleteInfo: 0,
      displaySubMenuButtons: 0,
      errors: {},
      medicalAid: medicalAid0,
      open: true,
    })
  }

  handleClickToEdit = () => {
    if (!this.props.isAdmin) {
      return
    }

    this.setState({
      buttonType: 'Edit',
      errors: {},
      mouseX: null,
      mouseY: null,
      open: true,
    })
  }

  handleClickToDelete = () => {
    if (!this.props.isAdmin) {
      return
    }

    this.setState({
      mouseX: null,
      mouseY: null,
      opendel: true,
    })
  }

  handleClose = () => {
    this.setState({
      mouseX: null,
      mouseY: null,
      open: false,
      opendel: false,
    })
  }

  handleDoubleClick = (event) => {
    const mouseX = this.state.mouseX ? null : event.clientX - 2
    const mouseY = this.state.mouseY ? null : event.clientY - 4
    this.setState({
      displaySubMenuButtons: 0,
      mouseX,
      mouseY,
    })
  }

  handleSingleClick = () => {
    this.setState({ displaySubMenuButtons: 1 })
  }

  handleCMenuClose = () => {
    this.setState({
      displaySubMenuButtons: 0,
      mouseX: null,
      mouseY: null,
    })
  }

  fetchKey = (event) => {
    this.setState({
      deleteInfo: 0,
      medicalAid: event.row,
    })
  }

  render() {
    const { classes } = this.props
    const { errors, open, opendel } = this.state
    const isAdmin = this.props.isAdmin === true

    const DeleteDialog = (
      <Dialog
        open={opendel}
        onClose={this.handleClose}
      >
        <DialogContent>
          <DialogContentText>
            Remove this medical aid from the list?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={this.handleClose}>
            Cancel
          </Button>
          <Button onClick={this.handleDeleteMedicalAid}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    )

    const Error =
      this.state.error === false ? (
        <div className={classes.subTitle}>&nbsp;MEDICAL AIDS LIST</div>
      ) : (
        <div className={classes.error}>{this.state.error}</div>
      )

    const addButton = isAdmin ? (
     <Tooltip title="Add Medical Aid" placement="top"> 
      <IconButton
        className={classes.floatingButton}
        color="primary"
        aria-label="Add Medical Aid"
        onClick={this.handleClickToCreate}
        size="large"
      >
        <AddCircleIcon style={{ fontSize: 60 }} />
      </IconButton>
     </Tooltip>
    ) : ''

    const editButton = isAdmin ? (
      <Tooltip title="Edit Medical Aid" placement="top">
       <IconButton
        className={classes.floatingButton}
        color="primary"
        aria-label="Edit Medical Aid"
        onClick={this.handleClickToEdit}
        size="large"
      >
        <EditIcon style={{ fontSize: 60 }} />
       </IconButton>
      </Tooltip> 
    ) : ''

    const deleteButton = isAdmin ? (
      <Tooltip title="Delete Medical Aid" placement="top">
       <IconButton
        className={classes.floatingButton}
        color="primary"
        aria-label="Delete Medical Aid"
        onClick={this.handleClickToDelete}
        size="large"
       >
        <DeleteIcon style={{ fontSize: 60 }} />
       </IconButton>
      </Tooltip>
    ) : ''

    const deleteInfo = this.state.deleteInfo ? (
      <Button className={classes.floatingButton} color="primary">
        Delete Successful
      </Button>
    ) : ''

    const subMenuButtons = this.state.displaySubMenuButtons ? (
      <div>
        {addButton}
        {editButton}
        {deleteButton}
        {deleteInfo}
      </div>
    ) : (
      <div>
        {addButton}
        {deleteInfo}
      </div>
    )

    const contextMenu = (
      <Menu
        className={classes.contextMenu}
        keepMounted
        open={this.state.mouseY !== null}
        onClose={this.handleCMenuClose}
        anchorReference="anchorPosition"
        anchorPosition={
          this.state.mouseY !== null && this.state.mouseX !== null
            ? { top: this.state.mouseY, left: this.state.mouseX }
            : undefined
        }
      >
        {isAdmin ? <MenuItem onClick={this.handleClickToEdit}>Edit Medical Aid</MenuItem> : ''}
        {isAdmin ? <MenuItem>---------------</MenuItem> : ''}
        {isAdmin ? <MenuItem onClick={this.handleClickToDelete}>Delete Medical Aid</MenuItem> : ''}
      </Menu>
    )

    if (this.state.uiLoading === true) {
      return (
        <main className={classes.content}>
          <div className={classes.toolbar} />
          {this.state.uiLoading && (
            <CircularProgress size={150} className={classes.uiProgess} />
          )}
        </main>
      )
    }

    return (
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <div>
          {Error}
          {subMenuButtons}
        </div>

        <div
          onDoubleClick={this.handleDoubleClick}
          onClick={this.handleSingleClick}
          style={{ cursor: 'context-menu' }}
        >
          {contextMenu}
          <div style={{ width: '600pt', height: '480pt' }}>
            <DataGrid
              className={classes.medicalAidGrid}
              rows={this.state.medicalAids}
              columns={medicalAidColumns}
              isRowSelectable={() => true}
              onCellClick={this.fetchKey}
            />
          </div>
        </div>

        {DeleteDialog}

        <Dialog
          fullScreen
          open={open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
          <AppBar position="static">
            <Toolbar variant="dense">
              <Tooltip title="Close Modal" placement="top">
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={this.handleClose}
                  aria-label="close"
                  size="large"
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
              <Typography variant="h6" className={classes.title}>
                {this.state.buttonType === 'Edit' ? 'Edit medical aid' : 'Create a new medical aid'}
              </Typography>
              <Button
                autoFocus
                color="inherit"
                onClick={this.handleCreateOrEditMedicalAid}
                className={classes.submitButton}
              >
                {this.state.buttonType === 'Edit' ? 'Save' : 'Submit'}
              </Button>
            </Toolbar>
          </AppBar>

          <form className={classes.form} noValidate>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <TextField
                  className={classes.formTextField}
                  variant="outlined"
                  required
                  id="name"
                  label="Medical Aid"
                  name="name"
                  autoComplete="name"
                  helperText={errors.name ? 'Medical aid name is required' : ''}
                  value={this.state.medicalAid.name || ''}
                  error={errors.name ? true : false}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  className={classes.formTextField}
                  variant="outlined"
                  required
                  id="email"
                  label="Email"
                  name="email"
                  autoComplete="email"
                  helperText={errors.email ? 'Valid email is required' : ''}
                  value={this.state.medicalAid.email || ''}
                  error={errors.email ? true : false}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!this.state.medicalAid.requiresDiscoveryPdf}
                      name="requiresDiscoveryPdf"
                      onChange={this.handleChange}
                    />
                  }
                  label="Requires Discovery wound-care PDF"
                />
              </Grid>
            </Grid>
          </form>
        </Dialog>
      </main>
    )
  }
}

export default withStyles(styles)(medicalAid)
